import React from 'react';

export const BCSpinner = () => <div className="BCSpinner"></div>;
